import { useTranslation } from 'react-i18next';
import { CopyButton } from '@/shared/components';
import CopyIcon from '@/shared/assets/copy-16-icon.svg?react';

type Props = {
  accountId: string;
};

export function AccountIdRow({ accountId }: Props) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col">
      <span className="medium5 text-primary">
        {t('personalAccount.userProfile.walletCardLabelText')}
      </span>
      <div className="flex items-center gap-[0.8rem] py-[0.2rem]">
        <span className="p6 text-secondary truncate flex-1" title={accountId}>
          {accountId}
        </span>
        <CopyButton
          value={accountId}
          size="sm"
          variant="ghost"
          icon={CopyIcon}
          buttonClassName="size-[1.6rem] p-0 text-tertiary hover:text-primary"
        />
      </div>
    </div>
  );
}
